export enum SelectionType {
    Energy = 1,
    Economic = 2
}
